import { useMemo } from 'react';

import { useAppStore } from '@common/stores/useAppStore';

import { useAuthStore } from '@entities/auth/stores/useAuthStore';
import { MyProfileInfo } from '@entities/profile/ui/MyProfileInfo';
import { useTaskLimits } from '@entities/tasks/hooks/useTaskLimits';

export const Profile = () => {
  const auth = useAuthStore();

  const { tasks } = useAppStore();

  const { limitReached, getAvailableCountWithinLimit } = useTaskLimits();

  const tasksCount = useMemo(
    () => (limitReached ? 0 : getAvailableCountWithinLimit(tasks)),
    [tasks, limitReached, getAvailableCountWithinLimit],
  );

  return (
    <MyProfileInfo
      profile={auth.user}
      verificationStatus={auth.verification_status}
      tasksCount={tasksCount}
    />
  );
};
